import styled from "styled-components";

export const Content = styled.div`

    button{
      box-shadow: 2px 2px 3px -1.5px rgba(0,0,0,0.15);
    }
    .grid4{
        display: grid;
        grid-template-columns: auto auto auto auto;
        margin-bottom: 4px;
        gap: 1px;

        button:first-child{
            grid-column: 1 / 3;
        }
        button{
          font-size: 0.72rem        
        }
        button.checked{
            background: var(--darkblue);
            color: #fff
        }
    }

    .grid3{
        display: grid;
        grid-template-columns: auto auto auto;
        margin-bottom: 10px;
        gap: 1px 4px;

        button{
          padding: 2px 0;
        }
        button.checked{
            background: rgba(50,70,91,0.4);
            color: var(--darkblue);
        }
        button:hover{
            background: rgba(50,70,91,0.2);
            color: var(--darkblue);
        }
        
    }

    .grid4auto,
    .grid5auto,
    .grid3to4{
        display: grid;
        grid-template-columns: auto auto auto auto;
        margin-bottom: 10px;
        gap: 1px 5px;

        button{
          padding: 10px 0;
        }
        button.checked{
          background: rgba(50,70,91,0.4);
            color: #fff;
        }
        button:hover{
            background: rgba(50,70,91,0.5);
            color: var(--darkblue);
        }
        button *{
          position: relative;
        }
        .regra1,
        .regra2,
        .regra3,
        .regra4{
          width: 1.2rem;
          height: 1.2rem;
          aspect-ratio: unset;
          margin: 0 3px 0 2px;
          left: unset;
        }
    }
    .grid5auto{
        display: grid;
        grid-template-columns: repeat(5, auto);
    }
    .grid3to4{
      display: grid;
      grid-template-columns: auto auto auto auto;
      margin-top: -8px;
      gap: 1px 4px;
      margin-bottom: 10px;

      button{
        padding: 2px 0;
      }
    }

    .noPaddingButton{
      button{
          padding: 2px 0;
      }        
    }

    .add{
        background: var(--pink);
        color: #fff;
        width: auto;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 0.9rem;

        &:hover{
            background: var(--darkblue);
        }
    }

    .flex{
        display: flex;
        justify-content: space-between;
        align-items: center;

        input[type=checkbox]{
            margin-right: 5px;
        }
    }

    .datepick{
        padding: 5px;
        margin-bottom: 5px;
        border-radius: 6px;
        border: solid 1px rgba(0,0,0,0.4);
        width: 100%;

        button{
            width: auto !important;
        }
    }
`